import React from 'react'
import styled from 'styled-components'
import { colors } from '@styles/theme'

const SLink = styled.a`
  color: ${colors.darkBlue};
`

export interface ILink {
  text: string
  url: string
}

export interface IStep {
  heading: string
  content: React.ReactNode
  link?: ILink
}

export const steps: IStep[] = [
  {
    heading: 'Заключите договор с СберНПФ',
    content: <>Договор заключается онлайн. Это займет не более 2-х минут. Потребуется только паспорт.</>,
    link: {
      text: 'Оформить',
      url: 'https://npo.npfsb.ru/?uniguid=AF2072&utm_source=sbernpfsite&utm_medium=lpdzo&utm_campaign=getkppcontract',
    },
  },
  {
    heading: 'Передайте в бухгалтерию Аэрофлот два подписанных заявления',
    content: (
      <>
        При оформлении договора онлайн СберНПФ направит заявление на удержание пенсионных взносов и заявление на
        получение налогового вычета на указанную в процессе заключения договора электронную почту.
      </>
    ),
    link: {
      text: 'Оформить',
      url: '#',
    },
  },
  {
    heading: 'Поздравляем! Вы - участник корпоративной пенсионной программы!',
    content: (
      <>
        Управляйте своим договором онлайн в Личном кабинете Фонда. Для этого достаточно{' '}
        <SLink href="https://lk.npfsb.ru/login">зарегистрироваться</SLink>. Это займет 2 минуты.
      </>
    ),
    link: {
      text: 'Оформить',
      url: '#',
    },
  },
]
